import { rapporterErreur } from "@app/lib/compta/erreurs_sentry";
import * as React from "react";

interface ErrorBoundaryProps {
  children: React.ReactNode;
  fallback: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    // This will send an error to Datadog RUM + logs so no need to manually log it
    console.error("Uncaught client side error: ", error);
    // compta : remontee vers GlitchTip quand la SPA l'a demarree (sinon ne fait rien).
    rapporterErreur(error, { origine: "ErrorBoundary" });
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback;
    }

    return this.props.children;
  }
}
